var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('atomic-layout-section',{attrs:{"section":"status"}},[_c('atomic-sort-dropdown',{staticClass:"pt-3 pt-md-0"},[_c('atomic-sort-expression',{attrs:{"label":"most-recent","expression":"date descending","state":"active"}}),_vm._v(" "),_c('atomic-sort-expression',{attrs:{"label":"relevance","expression":"relevancy"}})],1),_vm._v(" "),_c('atomic-did-you-mean'),_vm._v(" "),_c('atomic-notifications')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59af63ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/hcxf/hcxf-news-status.vue
// module id = 601
// module chunks = 0 1